import { NgModule } from '@angular/core';
import Color from '@arcgis/core/Color';
import Basemap from '@arcgis/core/Basemap';
import Map from '@arcgis/core/Map';
import MapView from '@arcgis/core/views/MapView';
import Draw from '@arcgis/core/views/draw/Draw';
import Graphic from '@arcgis/core/Graphic';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import Polyline from '@arcgis/core/geometry/Polyline';
import Sketch from '@arcgis/core/widgets/Sketch';
import BasemapGallery from '@arcgis/core/widgets/BasemapGallery';
import LocalBasemapsSource from '@arcgis/core/widgets/BasemapGallery/support/LocalBasemapsSource';
import BasemapGalleryViewModel from '@arcgis/core/widgets/BasemapGallery/BasemapGalleryViewModel';
import BufferParameters from '@arcgis/core/rest/support/BufferParameters';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';
import Point from '@arcgis/core/geometry/Point';
import Query from '@arcgis/core/rest/support/Query';
import esriRequest from '@arcgis/core/request';
import Extent from '@arcgis/core/geometry/Extent';
import Polygon from '@arcgis/core/geometry/Polygon';
import Circle from '@arcgis/core/geometry/Circle';
import Legend from '@arcgis/core/widgets/Legend';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
import Search from '@arcgis/core/widgets/Search';
import IdentifyParameters from '@arcgis/core/rest/support/IdentifyParameters';
import GroupLayer from '@arcgis/core/layers/GroupLayer';
import WMSLayer from '@arcgis/core/layers/WMSLayer';
import WMTSLayer from '@arcgis/core/layers/WMTSLayer';
import TileLayer from '@arcgis/core/layers/TileLayer';
import MapImageLayer from '@arcgis/core/layers/MapImageLayer';
import LabelClass from '@arcgis/core/layers/support/LabelClass';
import SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer';
import VectorTileLayer from '@arcgis/core/layers/VectorTileLayer';
import StatisticDefinition from '@arcgis/core/rest/support/StatisticDefinition';
import Expand from '@arcgis/core/widgets/Expand';
import LayerList from '@arcgis/core/widgets/LayerList';
import DistanceMeasurement2D from '@arcgis/core/widgets/DistanceMeasurement2D';
import AreaMeasurement2D from '@arcgis/core/widgets/AreaMeasurement2D';
import ActionButton from '@arcgis/core/support/actions/ActionButton';
import Print from '@arcgis/core/widgets/Print';
import PrintTemplate from '@arcgis/core/rest/support/PrintTemplate';
import ScaleBar from '@arcgis/core/widgets/ScaleBar';
import RelationshipQuery from '@arcgis/core/rest/support/RelationshipQuery';
import SketchViewModel from '@arcgis/core/widgets/Sketch/SketchViewModel';
import Compass from '@arcgis/core/widgets/Compass';

import * as symbolJsonUtils from '@arcgis/core/symbols/support/jsonUtils';
import * as rendererJsonUtils from '@arcgis/core/renderers/support/jsonUtils';
import * as identify from '@arcgis/core/rest/identify';
import * as execute from '@arcgis/core/rest/query';
import * as geometryEngine from '@arcgis/core/geometry/geometryEngine';
import * as geometryService from '@arcgis/core/rest/geometryService';
import * as locator from '@arcgis/core/rest/locator';
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils';
import LayerSearchSource from "@arcgis/core/widgets/Search/LayerSearchSource";

export let EsriPrintTemplate = PrintTemplate;
export let EsriRequest = esriRequest;
export let EsriSketchViewModel = SketchViewModel;
export let EsriRelationshipQuery = RelationshipQuery;
export let EsriScaleBar = ScaleBar;
export let EsriPrint = Print;
export let EsriActionButton = ActionButton;
export let EsriAreaMeasurement2D = AreaMeasurement2D;
export let EsriDistanceMeasurement2D = DistanceMeasurement2D;
export let EsriLayerList = LayerList;
export let EsriExpand = Expand;
export let EsriCircle = Circle;
export let EsriIdentify = identify;
export let EsriExecute = execute;
export let EsriWMSLayer = WMSLayer;
export let EsriWMTSLayer = WMTSLayer;
export let EsriTileLayer = TileLayer;
export let EsriMapImageLayer = MapImageLayer;
export let EsriLabelClass = LabelClass;
export let EsriSimpleRenderer = SimpleRenderer;
export let EsriSymbolJsonUtils = symbolJsonUtils;
export let EsriRendererJsonUtils = rendererJsonUtils;
export let EsriMap = Map;
export let EsriGeometryEngine = geometryEngine;
export let EsriGroupLayer = GroupLayer;
export let EsriBasemap = Basemap;
export let EsriIdentifyParameters = IdentifyParameters;
export let EsriSearch = Search;
export let EsriLocator = locator;
export let EsriSimpleLineSymbol = SimpleLineSymbol;
export let EsriSimpleFillSymbol = SimpleFillSymbol;
export let EsriSimpleMarkerSymbol = SimpleMarkerSymbol;
export let EsriLegend = Legend;
export let EsriGraphic = Graphic;
export let EsriMapView = MapView;
export let EsriFeatureLayer = FeatureLayer;
export let EsriGraphicsLayer = GraphicsLayer;
export let EsriVectorTileLayer = VectorTileLayer;
export let EsriColor = Color;
export let EsriPolyline = Polyline;
export let EsriSketch = Sketch;
export let EsriBasemapGallery = BasemapGallery;
export let EsriLocalBasemapsSource = LocalBasemapsSource;
export let EsriBasemapGalleryViewModel = BasemapGalleryViewModel;
export let EsriGeometryService = geometryService;
export let EsriBufferParameters = BufferParameters;
export let EsriSpatialReference = SpatialReference;
export let EsriPoint = Point;
export let EsriQuery = Query;
export let EsriExtent = Extent;
export let EsriPolygon = Polygon;
export let EsriStatisticDefinition = StatisticDefinition;
export let EsriLayerSearchSource = LayerSearchSource;
export let EsriCompass = Compass;
export let EsriDraw = Draw;
export let EsriReactiveUtils = reactiveUtils;

@NgModule({
  exports: [],
  declarations: [],
})
export class EsriModule {}
